export function getScript(url) {
	return new Promise(resolve => {
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.src = url

		// most browsers
		script.onload = function() {
			resolve()
		}

		// IE 6 & 7
		script.onreadystatechange = function () {
			if (this.readyState === 'complete') {
				resolve()
			}
		}
		document.getElementsByTagName('head')[0].appendChild(script)
	})
}